import React from "react";

const NonAuthLayout = ({ children }: any) => {
  return <React.Fragment>{children}</React.Fragment>;
};

export default NonAuthLayout;
